import React from "react";
import { Navigate, RouteObject } from "react-router-dom";
import Login from "src/pages/login";
import { Workflow } from "src/pages/workflow";
import { WorkflowAdd } from "src/pages/workflow/add";
import { WorkflowDetail } from "src/pages/workflow/detail";
import { SessionDetail } from "src/pages/session/detail";
import { Clippy } from "src/pages/clippy";
import { Image } from "src/pages/image";
import { Icon } from "src/pages/icon";
import { IconCreate } from "src/pages/iconCreate";
import { IconCreateWithImage } from "src/pages/iconCreateWithImage";
import { ProtectedRoute } from "src/components/ProtectedRoute"; // new import

export const routes: RouteObject[] = [
    {
        path: "/",
        element: <Navigate to="/workflow" />,
    },
    {
        path: "/login",
        element: <Login />,
    },
    {
        path: "/workflow",
        element: (
            <ProtectedRoute>
                <Workflow />
            </ProtectedRoute>
        ),
    },
    {
        path: "/workflow/add",
        element: (
            <ProtectedRoute>
                <WorkflowAdd />
            </ProtectedRoute>
        ),
    },
    {
        path: "/workflow/detail",
        element: (
            <ProtectedRoute>
                <WorkflowDetail />
            </ProtectedRoute>
        ),
    },
    {
        path: "/session/detail",
        element: (
            <ProtectedRoute>
                <SessionDetail />
            </ProtectedRoute>
        ),
    },
    {
        path: "/clippy",
        element: (
            <ProtectedRoute>
                <Clippy />
            </ProtectedRoute>
        ),
    },
    {
        path: "/image",
        element: (
            <ProtectedRoute>
                <Image />
            </ProtectedRoute>
        ),
    },
    {
        path: "/icon",
        element: (
            <ProtectedRoute>
                <Icon />
            </ProtectedRoute>
        ),
    },
    {
        path: "/icon-create",
        element: (
            <ProtectedRoute>
                <IconCreate />
            </ProtectedRoute>
        ),
    },
    {
        path: "/icon-create-with-style",
        element: (
            <ProtectedRoute>
                <IconCreateWithImage />
            </ProtectedRoute>
        ),
    },
    {
        path: "*",
        element: <div>404</div>,
    },
];
